/**
 * @namespace Plugins
 * @category Plugins
 * @module custom-console
 */
import Vue from 'vue'
import { getQueryStringValue } from '@/utils/querystring'
import { createCustomConsole } from '@/utils/logging'

const isDebugEnabled =
  (getQueryStringValue('verbose') || '').includes('1') ||
  (getQueryStringValue('debug') || '').includes('1')

const customConsole = createCustomConsole(
  import.meta.env.VUE_LOG_LEVEL || import.meta.env.NODE_ENV,
  window.console,
  isDebugEnabled
)
window.console = customConsole //Overwritte existing console

Vue.use({
  install() {
    Vue.$log = Vue.prototype.$log = customConsole
  },
})
